import { useState } from "react";
import { MenuFoldOutlined } from "@ant-design/icons";
import {
  HomeOutlined,
  TeamOutlined,
  QuestionCircleOutlined,
  MailOutlined,
  NotificationOutlined,
  ShoppingCartOutlined,
  WhatsAppOutlined,
  MessageOutlined,
  InfoCircleOutlined,
  AlignLeftOutlined,
  BulbOutlined,
  BorderlessTableOutlined,
  PhoneOutlined,
  ContactsOutlined,
  BarChartOutlined,
  SettingOutlined,
} from "@ant-design/icons";
import { Drawer, Menu } from "antd";
import images from "../../../assets";
import { Link } from "react-router-dom";

const items = [
  {
    key: "1",
    icon: <HomeOutlined />,
    label: "Dashboard",
    children: [
      {
        key: "overview",
        label: <Link to="/">Overview</Link>,
      },
      {
        key: "keyMetrics",
        label: <p>Key Metrics</p>,
      },
      {
        key: "recentActivities",
        label: <p>Recent Activities</p>,
      },
    ],
  },
  {
    key: "2",
    icon: <TeamOutlined />,
    label: "User Management",
    children: [
      {
        key: "userList",
        label: <Link to="/user-management/userList/">User List</Link>,
      },
      {
        key: "deletedUsers",
        label: <Link to="/user-management/deletedUsers/">Deleted Users</Link>,
      },
      {
        key: "deactivatedUsers",
        label: (
          <Link to="/user-management/deactivatedUsers/">Deactivated Users</Link>
        ),
      },
      {
        key: "expiredUsers",
        label: <Link to="/user-management/expiredUsers/">Expired Users</Link>,
      },
    ],
  },
  {
    key: "3",
    icon: <QuestionCircleOutlined />,
    label: "User Requests",
    children: [
      {
        key: "genderChange",
        label: <Link to="/user-requests/genderChange">Gender Change</Link>,
      },
      {
        key: "countryChange",
        label: <Link to="/user-requests/countryChange">Country Change</Link>,
      },
      {
        key: "dOBChange",
        label: <Link to="/user-requests/dobChange">DOB Change</Link>,
      },
      {
        key: "profileDescription",
        label: (
          <Link to="/user-requests/profileDescription">
            Profile Description
          </Link>
        ),
      },
      {
        key: "matchDescription",
        label: (
          <Link to="/user-requests/matchDescription">Match Description</Link>
        ),
      },
      {
        key: "trustBadge",
        label: <Link to="/user-requests/trustBadge">Trust Badge</Link>,
      },
    ],
  },
  {
    key: "4",
    icon: <ShoppingCartOutlined />,
    label: "Order Management",
    children: [
      {
        key: "orderList",
        label: <Link to="/order-management/orderList">Order List</Link>,
      },
      {
        key: "plans&Pricing",
        label: "Plans & Pricing",
      },
      {
        key: "promoCodes",
        label: <Link to="/order-management/promoCodes">Promo Codes</Link>,
      },
      {
        key: "paymentGateway",
        label: "Payment Gateway",
      },
      {
        key: "billingHistory",
        label: "Billing History",
      },
    ],
  },
  {
    key: "5",
    icon: <MailOutlined />,
    label: "Email",
    children: [
      {
        key: "sendEmail",
        label: "Send Email",
      },
      {
        key: "customerList",
        label: "Customer List",
      },
      {
        key: "emailHistory",
        label: <p>Email History</p>,
      },
    ],
  },
  {
    key: "6",
    icon: <MessageOutlined />,
    label: "Messages",
    children: [
      {
        key: "inbox",
        label: <p>Inbox</p>,
      },
      {
        key: "sendMessage",
        label: <p>Send Message</p>,
      },
      {
        key: "templates",
        label: <p>Templates</p>,
      },
      {
        key: "userChatHistory",
        label: <p>User Chat History</p>,
      },
      {
        key: "chatAI",
        label: <p>Chat AI</p>,
      },
    ],
  },
  {
    key: "7",
    icon: <NotificationOutlined />,
    label: "Notifications",
    children: [
      {
        key: "emailNotifi",
        label: "Email Notifications",
      },
      {
        key: "smsNotifi",
        label: <p>SMS Notifications</p>,
      },
      {
        key: "pushNotifi",
        label: "Push Notifications",
      },
    ],
  },
  {
    key: "8",
    icon: <WhatsAppOutlined />,
    label: "WhatsApp API",
    children: [
      {
        key: "sendMessage",
        label: <p>Send Message</p>,
      },
      {
        key: "inbox",
        label: <p>Inbox</p>,
      },
      {
        key: "templates",
        label: <p>Templates</p>,
      },
    ],
  },
  {
    key: "9",
    icon: <InfoCircleOutlined />,
    label: "Support",
    children: [
      {
        key: "reportIssue",
        label: <p>Report issue</p>,
      },
      {
        key: "supportTickets",
        label: <p>Support Tickets</p>,
      },
      {
        key: "userFeedbacks",
        label: (
          <Link to="/support/userfeedback">
            <p>User Feedbacks</p>
          </Link>
        ),
      },
      {
        key: "supportAI",
        label: <p>Support AI</p>,
      },
    ],
  },
  {
    key: "10",
    icon: <AlignLeftOutlined />,
    label: "Reports & Analytics",
    children: [
      {
        key: "userActivity",
        label: <p>User Activity</p>,
      },
      {
        key: "revenue",
        label: <p>Revenue</p>,
      },
      {
        key: "countryInsights",
        label: <p>Country Insights</p>,
      },
    ],
  },
  {
    key: "11",
    icon: <BulbOutlined />,
    label: "Marketing",
    children: [
      {
        key: "campaigns",
        label: <p>Campaigns</p>,
      },
      {
        key: "promotions",
        label: <p>Promotions</p>,
      },
      {
        key: "archives",
        label: <p>Archives</p>,
      },
      {
        key: "digital",
        label: <p>Digital</p>,
      },
    ],
  },
  {
    key: "12",
    icon: <BorderlessTableOutlined />,
    label: "SEO",
    children: [
      {
        key: "multiplePages",
        label: <Link to="/moneyPage">Multiple Pages</Link>,
      },
      {
        key: "sitemaps",
        label: "Sitemaps",
      },
      {
        key: "robotsTxt",
        label: "Robots.txt",
      },
    ],
  },
  {
    key: "18",
    icon: <BorderlessTableOutlined />,
    label: "Blog",
    children: [
      {
        key: "blogs",
        label: <Link to="/blog">Blogs</Link>,
      },
      {
        key: "addBlog",
        label: <Link to="/addBlog">Add Blog</Link>,
      },
      {
        key: "authors",
        label: <Link to="/author">Authors</Link>,
      },
      {
        key: "categories",
        label: <Link to="/category">Categories</Link>,
      },
    ],
  },
  {
    key: "13",
    icon: <PhoneOutlined />,
    label: "Tele Sales (S.Admin)",
    children: [
      {
        key: "assignLeads",
        label: <p>Assign Daily Leads</p>,
      },
      {
        key: "leadProgress",
        label: <p>Lead Progress</p>,
      },
      {
        key: "setTargets",
        label: <p>Set Targets</p>,
      },
      {
        key: "leadsArchives",
        label: <p>Leads Archives</p>,
      },
      {
        key: "executiveList",
        label: <p>Executive List</p>,
      },
      {
        key: "salesReport",
        label: <p>Sales Report</p>,
      },
      {
        key: "followUps",
        label: <p>Follow Ups</p>,
      },
    ],
  },
  {
    key: "14",
    icon: <PhoneOutlined />,
    label: "Tele Sales (T.Exec)",
    children: [
      {
        key: "dashboard",
        label: <p>Dashboard</p>,
      },
      {
        key: "leadProgress2",
        label: <p>Lead Progress</p>,
      },
      {
        key: "myTargets",
        label: <p>My Targets</p>,
      },
      {
        key: "mySales",
        label: <p>My Sales</p>,
      },
      {
        key: "myLeads",
        label: <p>My Leads</p>,
      },
      {
        key: "followUps2",
        label: <p>Follow Ups</p>,
      },
    ],
  },
  {
    key: "15",
    icon: <ContactsOutlined />,
    label: "Contents",
    children: [
      {
        key: "emailContents",
        label: <p>Email Contents</p>,
      },
      {
        key: "smsContnent",
        label: <p>SMS Contnent</p>,
      },
      {
        key: "bannerModule",
        label: <p>Banner Module</p>,
      },
      {
        key: "staticPages",
        label: <p>Static Pages</p>,
      },
      {
        key: "testimonials",
        label: <p>Testimonials</p>,
      },
      {
        key: "faqs",
        label: <p>FAQs</p>,
      },
      {
        key: "presetMessages",
        label: <p>Preset Messages</p>,
      },
      {
        key: "successStories",
        label: <p>Success Stories</p>,
      },
      {
        key: "miscellaneous",
        label: <p>Miscellaneous</p>,
      },
      {
        key: "personality",
        label: <p>Personality</p>,
      },
      {
        key: "hobbies",
        label: <p>Hobbies</p>,
      },
    ],
  },
  {
    key: "16",
    icon: <BarChartOutlined />,
    label: "System Logs",
    children: [
      {
        key: "loginHistory",
        label: <p>Login History</p>,
      },
      {
        key: "activityLogs",
        label: <p>Activity Logs</p>,
      },
      {
        key: "errorLogs",
        label: <p>Error Logs</p>,
      },
      {
        key: "otherLogs",
        label: <p>Other Logs</p>,
      },
    ],
  },
  {
    key: "17",
    icon: <SettingOutlined />,
    label: "Settings",
    children: [
      {
        key: "countrySettings",
        label: <p>Country Settings</p>,
      },
      {
        key: "generalSettings",
        label: (
          <Link to="/settings/generalsettings">
            <p>General Settings</p>
          </Link>
        ),
      },
      {
        key: "userRoles",
        label: <p>User Roles</p>,
      },
      {
        key: "notification",
        label: <p>Notification</p>,
      },
      {
        key: "security",
        label: <p>Security</p>,
      },
      {
        key: "currencySettings",
        label: <p>Currency Settings</p>,
      },
    ],
  },
];

const getLevelKeys = (items1) => {
  const key = {};
  const func = (items2, level = 1) => {
    items2.forEach((item) => {
      if (item.key) {
        key[item.key] = level;
      }
      if (item.children) {
        func(item.children, level + 1);
      }
    });
  };
  func(items1);
  return key;
};
const levelKeys = getLevelKeys(items);

export default function MainSidebar() {
  const [stateOpenKeys, setStateOpenKeys] = useState(["1"]);
  const [open, setOpen] = useState(false);

  const onOpenChange = (openKeys) => {
    const currentOpenKey = openKeys.find(
      (key) => stateOpenKeys.indexOf(key) === -1
    );
    // open
    if (currentOpenKey !== undefined) {
      const repeatIndex = openKeys
        .filter((key) => key !== currentOpenKey)
        .findIndex((key) => levelKeys[key] === levelKeys[currentOpenKey]);
      setStateOpenKeys(
        openKeys
          // remove repeat key
          .filter((_, index) => index !== repeatIndex)
          // remove current level all child
          .filter((key) => levelKeys[key] <= levelKeys[currentOpenKey])
      );
    } else {
      // close
      setStateOpenKeys(openKeys);
    }
  };
  const showDrawer = () => {
    setOpen(true);
  };
  const onClose = () => {
    setOpen(false);
  };
  return (
    <div className="collapse-sidebar">
      <p className="p-2 cursor-pointer" onClick={showDrawer}>
        <MenuFoldOutlined />
      </p>
      <Drawer
        className="main-siderbar-menu"
        placement="left"
        width={300}
        onClose={onClose}
        closable={false}
        open={open}
      >
        <div className="flex flex-col">
          <div className="flex flex-col gap-2 pb-4 justify-center items-center relative">
            <div className="absolute top-0 right-4 cursor-pointer">
              <img
                onClick={onClose}
                src={images.sidebarCloseIcon}
                alt="Close"
              />
            </div>
            <Link to="/">
              <img onClick={onClose} src={images.whiteLogo} alt="Logo" />
            </Link>
            <p>Admin Dashboard</p>
          </div>

          <Menu
            onClick={onClose}
            className="user-profile-sidebar main-siderbar-items"
            mode="inline"
            defaultSelectedKeys={["1"]}
            openKeys={stateOpenKeys}
            onOpenChange={onOpenChange}
            style={{
              width: "100%",
            }}
            items={items}
          />
        </div>
      </Drawer>
    </div>
  );
}
